import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompetenciesComponent } from './competencies.component';
import { SubCompetencyComponent } from './sub-competency/sub-competency.component';
import { CompetencyComponent } from './competency/competency.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { RoleGuardGuard } from 'src/app/auth/role-guard.guard';
import { SubCompetencyPageComponent } from './competency/sub-competency-page/sub-competency-page.component';
import { GSDStaticComponent } from 'src/app/gsdstatic/gsdstatic.component';
import { EmployeeDetailsComponent } from '../employee-details/employee-details.component';
import { ToolsComponentComponent } from '../tools-component/tools-component.component';
import { TrainingsTrackerGridComponent } from '../trainings_tracker/trainings_tracker_header/trainings_tracker_grid/trainings_tracker_grid.component';
import { AddTrainingsComponent } from '../Trainings/add-trainings/add-trainings.component';
import { AddToolsComponent } from '../tools-component/Add-tools/add-tools/add-tools.component';
import { SkillRepoEmployeesComponent } from '../skill-repo-employees/skill-repo-employees.component';


const routes: Routes = [
  {
    path: '',
    component: CompetencyComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/CMF Portal'
    },
  },
  {
    path: `:competency`,
    component: SubCompetencyComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: `Home/CMF Portal/:competency`
    }
  },
  // {
  //   path: `:competency/:subcompetency`,
  //   component: SubCompetencyComponent,
  //   canActivate: [AuthGuard, RoleGuardGuard],
  //   data: {
  //     roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
  //     preload: true,
  //     breadcrumb: 'Home/CMF Portal/:competency'
  //   }
  // },
  {
    path: ':competency/Service-Line-Maturity-Measures',
    component: GSDStaticComponent,
    data: {
      breadcrumb: `Home/CMF Portal/:competency/Service Line Maturity Measures`,
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    }
  },
  {
    path: `:competency/:subcompetency/Resources/:filter/Employee-details`,
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Resources/:filter/Employee Details'
    }
  },
  {
    path: `:competency/:subcompetency/Certificates/:filter/Employee-details`,
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Certificates/:filter/Employee Details'
    }
  },
  {
    path: `:competency/:subcompetency/Others`,
    component: SubCompetencyComponent,
    data: {
      breadcrumb: `Home/CMF Portal/:competency/:subcompetency/Others`,
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
    }
  },
  {
    path: `:competency/:subcompetency/Others/:tools`,
    component: ToolsComponentComponent,
    data: {
      breadcrumb: `Home/CMF Portal/:competency/:subcompetency/Others/:tools`,
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
    }
  },
  {
    path: `:competency/:subcompetency/Trainings`,
    component: SubCompetencyComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: `Home/CMF Portal/:competency/:subcompetency/Trainings`,
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
    }

  },
  {
    path: `:competency/:subcompetency/Trainings/:trainings`,
    component: TrainingsTrackerGridComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: `Home/CMF Portal/:competency/:subcompetency/Trainings/:trainings`,
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
    }

  },
  {
    path: `:competency/:subcompetency/Trainings/:trainings/addTrainings`,
    component: AddTrainingsComponent,
    data: {
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Trainings/:trainings/AddTrainings',
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
    }
  },
  {
    path: `:competency/:subcompetency/Others/:tools/addTools`,
    component: AddToolsComponent,
    data: {
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Others/:tools/AddTools',
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
    }
  },
  {
    path: `:competency/:subcompetency/Resources/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Resources/:filter'
    }
  },
  {
    path: `:competency/:subcompetency/Resources`,
    component: SubCompetencyComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Resources/:filter'
    }
  },
  {
    path: `:subcompetency/:resource`,
    component: SubCompetencyComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: `Home/CMF Portal/:subcompetency/:resource`
    }
  },
  {
    path: `:competency/:subcompetency/Certificates`,
    component: SubCompetencyComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Certificates/:filter'
    }
  },
  {
    path: `:competency/:subcompetency/Certificates/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Certificates/:filter'
    }
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompetenciesRoutingModule { }
